'use strict';

var svaneTvis = svaneTvis || {};
svaneTvis.megamenu = svaneTvis.megamenu || new function () {

    this.init = function () {
        // Expand function
        const expandButtons = document.querySelectorAll('.js-expand-button');
        for (let i = 0; i < expandButtons.length; i++) {
            const expandButton = expandButtons[i];
            expandButton.addEventListener('click', function(){
                
                if (expandButton.parentElement.classList.contains('site-navigation-list__item--active')) {
                    expandButton.parentElement.classList.remove('site-navigation-list__item--active');
                } else {
                    for (let i = 0; i < expandButtons.length; i++) {
                        const element = expandButtons[i];
                        element.parentElement.classList.remove('site-navigation-list__item--active');
                    }
                    expandButton.parentElement.classList.add('site-navigation-list__item--active');
                }
            });
        }
        //Hover intent - Megamenu
        if (window.innerWidth > 1050) {
            var megaMenuItems = document.querySelectorAll('.site-navigation-list__item');
            for (var i = 0; i < megaMenuItems.length; i++) {
                var megaMenuItem = megaMenuItems[i];
                hoverintent(megaMenuItem, function () {
                    this.classList.add('site-navigation-list__item--show-mega');
                }, function () {
                    this.classList.remove('site-navigation-list__item--show-mega');
                }).options({
                    timeout: 400,
                    interval: 55
                });
                
            }
            var imageItems = document.querySelectorAll('.site-navigation-mega__sub-link');
            for (var j = 0; j < imageItems.length; j++) {
                var imageItem = imageItems[j];
                imageItem.addEventListener('mouseover', function() {
                    var currentEl = this;
                    if (currentEl.hasAttribute('data-image')) {
                        var parentEl = currentEl.closest('.site-navigation-mega');
                        var imageHolder = parentEl.querySelector('.js-site-navigation-mega__image-holder');
                        var currentImage = currentEl.getAttribute('data-image');
                        imageHolder.setAttribute('src', currentImage);
                    }
                });
            }
        }
    };
}();
